import React from "react";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../../CustomDropdown/CustomDropdown";
import styles from "../CreateParameterPopup.module.css";
import LabelParameters from "../LabelParameters";

const Phone = ({
  parameterData,
  setParameterData,
  handleChange,
  editingInput,
  setEditingInput,
}) => {
  const [t] = useTranslation("Contacts");

  const options = [
    "España, (+34)",
    "Estados Unidos, (+1)",
    "México, (+52)",
    "Argentina, (+54)",
    "Brasil, (+55)",
    "Reino Unido, (+44)",
    "Francia, (+33)",
    "Alemania, (+49)",
  ];

  return (
    <>
      <LabelParameters
        value={parameterData.countryCode}
        text={"phone"}
        editingInput={editingInput}
        setEditingInput={setEditingInput}
      >
        <CustomDropdown
          generalStyleFilterSort={{
            padding: "3px 0px 3px 0px",
            margin: "0px",
            height: "max-content",
            minWidth: "115px",
            color: "#717171",
            gap: "3px",
          }}
          editable={true}
          setSelectedOption={(option) =>
            handleChange({ name: "countryCode", newValue: option })
          }
          customStyles={styles.FlagsDropdown}
          editing={true}
          // hasObject={true}
          options={options}
          selectedOption={parameterData?.countryCode || t("selectCountry")}
        />
        <input
          type="text"
          value={parameterData?.phoneNumber}
          name={"phoneNumber"}
          onChange={handleChange}
          placeholder="000 000 000"
          className={styles.inputParameter}
        />
      </LabelParameters>
    </>
  );
};

export default Phone;
